// extracted by mini-css-extract-plugin
module.exports = {"container":"ValidatedPage_container__M0MlH","loader":"ValidatedPage_loader__K_x_T","spin":"ValidatedPage_spin__QwRFp","modalContainer":"ValidatedPage_modalContainer__V8EDG"};